// Dashboard · App — horizontal grid of all app.geovinum.io modules.
// Each card links to the dedicated management page.
import { Link } from "react-router-dom";
import { Users, CreditCard, BookOpen, ShoppingBag, Database, ArrowRight } from "lucide-react";

const MODULES = [
  { to: "/admin/app-users",         icon: Users,       label: "Users",         desc: "Comptes utilisateurs app.geovinum.io" },
  { to: "/admin/app-subscriptions", icon: CreditCard,  label: "Subscriptions", desc: "Abonnements Stripe actifs & historique" },
  { to: "/admin/app-academy",       icon: BookOpen,    label: "Academy · IA",  desc: "Parcours & cours générés par IA" },
  { to: "/admin/app-shop-orders",   icon: ShoppingBag, label: "Shop orders",   desc: "Commandes passées depuis l'app" },
  { to: "/admin/app-rag",           icon: Database,    label: "RAG corpus IA", desc: "Base de connaissance du chatbot" },
];

const AdminDashboardAppPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6" data-testid="admin-dashboard-app">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-widest text-[color:var(--gv-pink)] mb-1">Dashboard</div>
        <h1 className="font-display text-3xl text-[color:var(--gv-ink)]">App geoVINUM</h1>
        <p className="text-[13.5px] text-[color:var(--gv-ink)]/60 mt-1 max-w-2xl">
          Tous les modules de la plateforme app.geovinum.io en un coup d'œil.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="dashboard-app-grid">
        {MODULES.map(({ to, icon: Icon, label, desc }) => (
          <Link
            key={to}
            to={to}
            className="group bg-white border border-[color:var(--gv-line)] rounded-[6px] p-5 hover:border-[color:var(--gv-pink)] transition-colors"
            data-testid={`dashboard-app-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="w-10 h-10 rounded-[5px] bg-[color:var(--gv-pink)]/10 flex items-center justify-center">
                <Icon size={20} className="text-[color:var(--gv-pink)]" />
              </div>
              <ArrowRight size={16} className="text-[color:var(--gv-ink)]/30 group-hover:text-[color:var(--gv-pink)] group-hover:translate-x-0.5 transition-all" />
            </div>
            <div className="font-display text-lg text-[color:var(--gv-ink)]">{label}</div>
            <div className="text-[12.5px] text-[color:var(--gv-ink)]/60 mt-1">{desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboardAppPage;
